/**
 * External Dependencies
 */
import { Component } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Dependencies
 */
import { requestGraphCubeMeta } from 'state/graph-cube/actions';

class GraphCubeMetaData extends Component {
    UNSAFE_componentWillMount() {
        this.request(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // some kind of logic to check if it needs to reload the data
    }

    request(props) {
        props.requestGraphCubeMeta();
    }

    render() {
        return null;
    }
}

export default connect(
    (state, ownProps) => {
        return {};
    },
    {
        requestGraphCubeMeta,
    },
)(GraphCubeMetaData);
